import React from 'react';
import * as styles from './detailedCurriculum.module.scss';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_HERO } from '@src/constants/LeadGenerationConstants/index';
import useRequestCallback from './useRequestCallback';

const FACTS = [
  { b: '6', t: 'months + 2-week interview sprint' },
  { b: '60+', t: 'live sessions' },
  { b: '17', t: 'builds — 10 mini projects · 6 guided · 1 capstone' },
  { b: '+4', t: 'optional self-builds' },
  { b: 'Industry', t: 'mentors' },
  { b: '~10 h', t: 'a week' },
];

const CTA_CLASS = 'h-auto w-auto shrink-0 rounded-xl px-[22px] py-3 text-[15px] shadow-none hover:shadow-none';

const Hero = () => {
  const onSubmitPageOne = useRequestCallback();
  return (
    <div className={styles.hero}>
      <div className={styles.wrap}>
        <span className={styles.kicker}>Fellowship Program in AI Engineering</span>
        <h1>
          The detailed curriculum
          <br />
          <span className={styles.g}>and projects.</span>
        </h1>
        <p>
          Every sprint, every session theme, and every build explained in plain language — what
          it is, the business problem it solves, what you build, and how success is measured. Six
          4-week build sprints, a 2-week interview sprint, 17 builds plus 4 optional ones.
        </p>
        <div className={styles.facts}>
          {FACTS.map((f) => (
            <span className={styles.fact} key={f.t}>
              <b>{f.b}</b> {f.t}
            </span>
          ))}
        </div>
        <div className={styles.ctas}>
          <LeadGenerationButton
            text="Talk to an Advisor"
            isOnePageForm
            formHeading="Request Callback"
            pageOneButtonText="Call me back"
            onSubmitPageOne={onSubmitPageOne}
            buttonLocation={LEAD_GEN_HERO}
            className={CTA_CLASS}
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
